import { render, staticRenderFns } from "./contestFeedbackForm.html?vue&type=template&id=af708956&scoped=true&"
import script from "./contestFeedbackForm.js?vue&type=script&lang=js&"
export * from "./contestFeedbackForm.js?vue&type=script&lang=js&"
import style0 from "./contestFeedbackForm.scss?vue&type=style&index=0&id=af708956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af708956",
  null
  
)

export default component.exports